import React, { useEffect, useMemo, useState } from 'react';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import DarwinFilterOption from 'pages/darwinRecord/components/DarwinFilterOption';
import { placeholderToFilterKey } from 'pages/darwinRecord/darwinRecordUtils';

const DarwinRegularizationFilter = ({
  filterConfig = [],
  appliedFilters = {},
  onApply,
}) => {
  const [draft, setDraft] = useState(appliedFilters || {});

  useEffect(() => {
    setDraft(appliedFilters || {});
  }, [appliedFilters]);

  const activeChips = useMemo(() => {
    return filterConfig
      .map((field) => {
        const key = placeholderToFilterKey(field.place_holder);
        const value = key ? draft[key] : undefined;
        if (!key || value === undefined || value === '') return null;

        if (field.field === 'dropdown') {
          const option = (field.values || []).find((item) => item.id === value);
          return {
            key,
            label: `${field.place_holder}: ${option?.name || value}`,
          };
        }

        if (field.field === 'date') {
          return {
            key,
            label: `${field.place_holder}: ${value}`,
          };
        }

        return null;
      })
      .filter(Boolean);
  }, [draft, filterConfig]);

  const handleSubmit = (event) => {
    event.preventDefault();
    onApply(draft);
  };

  return (
    <form onSubmit={handleSubmit} className="darwin-filter-panel">
      {activeChips.length > 0 ? (
        <div className="darwin-filter-panel__selection darwin-filter-panel__selection--wrap">
          <span className="darwin-filter-panel__selection-label">Selected</span>
          <div className="darwin-filter-panel__chips">
            {activeChips.map((chip) => (
              <span key={chip.key} className="darwin-filter-panel__chip">
                {chip.label}
              </span>
            ))}
          </div>
        </div>
      ) : null}

      {filterConfig.map((field) => {
        const key = placeholderToFilterKey(field.place_holder);
        if (!key) return null;

        if (field.field === 'dropdown') {
          const options = field.values || [];
          return (
            <div key={field.place_holder} className="darwin-filter-panel__section">
              <div className="darwin-filter-panel__header">
                <p className="darwin-filter-panel__title">{field.place_holder}</p>
              </div>
              <div className="darwin-filter-panel__options">
                {options.length === 0 ? (
                  <p className="darwin-filter-panel__empty">No options available</p>
                ) : (
                  options.map((option) => (
                    <DarwinFilterOption
                      key={option.id}
                      id={`darwin-filter-${key}-${option.id}`}
                      name={`darwin-filter-${key}`}
                      label={option.name}
                      isSelected={draft[key] === option.id}
                      onClick={() =>
                        setDraft((prev) => ({
                          ...prev,
                          [key]: prev[key] === option.id ? undefined : option.id,
                        }))
                      }
                    />
                  ))
                )}
              </div>
            </div>
          );
        }

        if (field.field === 'date') {
          return (
            <div key={field.place_holder} className="darwin-filter-panel__section">
              <div className="darwin-filter-panel__header">
                <p className="darwin-filter-panel__title">{field.place_holder}</p>
              </div>
              <div className="darwin-filter-panel__date-field">
                <input
                  id={`darwin-filter-${key}`}
                  type="date"
                  className="form-control darwin-filter-panel__date-input"
                  value={draft[key] || ''}
                  onChange={(event) =>
                    setDraft((prev) => ({
                      ...prev,
                      [key]: event.target.value || undefined,
                    }))
                  }
                />
              </div>
            </div>
          );
        }

        return null;
      })}

      <div className="btn-wrapper">
        <button type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src={Images?.ArrowRight || '../images/arrow-right.png'} alt="" />
        </button>
        <br />
        <br />
        <button type="button" className="btn btn-primary" onClick={() => onApply({})}>
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default DarwinRegularizationFilter;
